<template>
  <CRow>
    <CCol v-for="item in counts" :key="item.type" class="">
      <CCard class="countCard p-3">
        <CCardBody class="d-flex flex-column justify-content-between">
          <div class="countCard_Header d-flex justify-content-between content-center mb-4">
            <h6>{{ $t(`settings.planAndBilling.header.type.${item.type}`) }}</h6>
            <CIcon :name="selectIcon(item.type)" :height="20" viewBox="0 0 32 32" size="custom-size" class="mr-2 text-gray-800" />
          </div>
          <div class="countCard_body">
            <div v-if="item.period">
              <span v-if="isCorporate" class="mb-1 text-get-Addon">{{ $t('settings.planAndBilling.overview.text.corporate.buy') }}</span>
              <div v-else>
                <div v-if="item.total > 0">
                  <span class="font-weight-bold h4"> {{ formatNumber(item.total) }} </span>
                  <span v-if="!isFree" class="font-weight-bolder font-sm"> / {{ handlePediod(item.period) }}</span>
                </div>
                <div v-else class="text-center">
                  <div class="mb-1 text-get-Addon">{{ $t('settings.planAndBilling.overview.text.getNewAddon') }}</div>
                  <div>
                    <CButton class="px-4" variant="outline" color="primary" @click="$router.push({ name: 'manage-balance' })">{{
                      $t('settings.planAndBilling.overview.button.buyAddon')
                    }}</CButton>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="item.used != null" class="mt-2">
              <div class="d-flex justify-content-between mb-3">
                <div class="font-weight-bold h6">
                  {{ formatNumber(item.used) }}
                  <span v-if="!isCorporate">/ {{ formatNumber(item.limit) }}</span>
                </div>
                <span class="font-weight-bold h6" v-if="calcPercentage(item.percent)"> {{ calcPercentage(item.percent) }} </span>
              </div>
              <CProgress :value="item.used" :max="item.limit" color="blue"></CProgress>
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>
<script>
import { enumPlanPeriod } from '@/utils/enumsUtils.js'
import { formatNumber } from '@/utils/numbersFormatUtil.js'

export default {
  name: 'OverViewCounts',
  props: {
    counts: {
      type: Array,
      default: () => [],
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    isCorporate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handlePediod(value) {
      return enumPlanPeriod(value)?.toLowerCase()
    },
    calcPercentage(percent, total) {
      const value = Math.floor(percent * 100)
      return value ? `${value}%` : false
    },
    formatNumber(value) {
      return formatNumber(value)
    },
    selectIcon(type) {
      switch (type) {
        case 'contacts':
          return 'allAudience'
        case 'email':
          return 'email'
        case 'sms':
          return 'sms'
        default:
          return null
      }
    },
  },
}
</script>

<style lang="scss" scope>
.countCard {
  height: 165px;

  .progress,
  .progress-bar {
    border-radius: 70px;
    height: 12px;
  }
}

.text-get-Addon {
  color: $gray-600;
}
</style>
